// Extracted from https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-editor-plugins/confluence-editor/src/main/resources/tinymce3/plugins/table/atlassian-table.js

// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function getSelectedHighlightColour() {
	return $('#table-highlight-group').attr('data-highlight-colour') || '';
}

function isSelectedColour(highlights) {
	const hlColour = getSelectedHighlightColour();
	let i;
	let l;
	let cellColour;
	for (i = 0, l = highlights.length; i < l; i++) {
		cellColour = highlights.eq(i).attr('data-highlight-colour') || '';
		if (cellColour !== hlColour) {
			return false;
		}
	}
	return true;
}

/* Keep simple only consider start position -> means cursor gets collapsed. */
function isCursorInCell(editor, $origEl) {
	const $node = $(editor.selection.getNode());
	if (!$node.length) {
		return false;
	}

	if ($node[0] === $origEl[0]) {
		return true;
	}

	return !!$node.closest($origEl).length;
}

function changeTagType(ed, $origEl, newTag) {
	if (!$origEl.length) {
		return;
	}

	const cursorInCell = isCursorInCell(ed, $origEl);

	const origEl = $origEl[0];
	const doc = origEl.ownerDocument;
	const newEl = doc.createElement(newTag);

	const attrs = origEl.attributes;
	for (let i = 0, l = attrs.length; i < l; i++) {
		const attr = attrs[i];
		newEl.setAttribute(attr.nodeName, attr.nodeValue);
	}

	while (origEl.hasChildNodes()) {
		newEl.appendChild(origEl.firstChild);
	}

	origEl.parentNode.replaceChild(newEl, origEl);

	if (cursorInCell) {
		// Put cursor at end of cell if cursor was previously in this cell
		ed.selection.select(newEl, true);
		ed.selection.collapse();
	}
	return $(newEl);
}

const RteTable = {
	convertToNormalCells(editor, cells) {
		cells.filter('th').each(function () {
			let $el = $(this);
			$el = changeTagType(editor, $el, 'td');
			$el.removeClass('confluenceTh');
			$el.addClass('confluenceTd');
		});
	},
	convertToHeadingCells(editor, cells) {
		cells.filter('td').each(function () {
			let $el = $(this);
			$el = changeTagType(editor, $el, 'th');
			$el.removeClass('confluenceTd');
			$el.addClass('confluenceTh');
		});
	},
	areCellsHeadings(cells) {
		const headings = cells.filter('th');
		const headingCount = headings.length;
		return cells.length === headingCount;
	},
	isColumnHeading(table, index) {
		const rows = $(table).children('tbody').children('tr');
		if (rows.length === 1) {
			return false; // special case for single row table
		}
		const headingColumnCells = rows.children().filter(`th:nth-child(${index})`);
		return headingColumnCells.length === rows.length;
	},
	areCellsHighlighted(cells) {
		const highlighted = cells.filter('td[data-highlight-colour],th[data-highlight-colour]');
		const highlightedCount = highlighted.length;
		return cells.length === highlightedCount && isSelectedColour(highlighted);
	},
	/**
	 * Returns true if the given column index of the table is highlighted in the same colour. Note that the index is 1-based.
	 */
	isColumnHighlighted(table, index) {
		const columnCells = $(table).children('tbody').children('tr').children('th,td').nthCol(index);
		const highlighted = columnCells.filter('td[data-highlight-colour],th[data-highlight-colour]');
		const highlightedCount = highlighted.length;

		if (columnCells.length !== highlightedCount) {
			return false;
		}

		const highlightColour = columnCells.eq(0).attr('data-highlight-colour');
		for (let i = 1, l = columnCells.length; i < l; i++) {
			if (highlightColour !== columnCells.eq(i).attr('data-highlight-colour')) {
				return false;
			}
		}
		return true;
	},

	getSelectedHighlightColour,
};

export default RteTable;
